/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The Roles enum
 */
export enum RolesEnum {
  MVP_PROGRAM_OWNER = "mvp-program-owner",
  MVP_REVIEWER = "mvp-reviewer", // Renamed to Community Manager / Community Program Manager
  MVP_TECH_AREA_VALIDATOR = "mvp-tech-area-validator", // Renamed to Product Group Partner
  MVP_BENEFITS_MANAGER = "mvp-benefits-manager",
  MVP_BUSINESS_GROUP = "mvp-business-group",
  MVP_EXECUTIVE = "mvp-executive",
  MSA_PROGRAM_OWNER = "msa-program-owner",
  MSA_REVIEWER = "msa-reviewer",
  MSA_BENEFITS_MANAGER = "msa-benefits-manager",
  MSA_GUEST = "msa-guest",
  RD_PROGRAM_OWNER = "rd-program-owner",
  RD_REVIEWER = "rd-reviewer",
  RD_GUEST = "rd-guest",
  RD_BENEFITS_MANAGER = "rd-benefits-manager",
}

/**
 * The Permissions enum
 */
export enum PermissionsEnum {
  MVP_VIEW_USERS = "mvp-view-users",
  MVP_UPDATE_USERS = "mvp-update-users",
  MVP_VIEW_APPLICATIONS = "mvp-view-applications",
  MVP_SCORE_APPLICATIONS = "mvp-score-applications",
  MVP_VIEW_BENEFITS = "mvp-view-benefits",
  MVP_UPDATE_BENEFITS = "mvp-update-benefits",
  MVP_VIEW_ACCESS_CONTROL = "mvp-view-access-control",
  MVP_UPDATE_ACCESS_CONTROL = "mvp-update-access-control",
  MVP_VIEW_DISTRIBUTIONS_LIST = "mvp-view-distributions-list",
  MVP_UPDATE_DISTRIBUTIONS_LIST = "mvp-update-distributions-list",
  MVP_DOWNLOAD_APPLICATIONS = "mvp-download-applications",
  MVP_VIEW_DEMOGRAPHICS = "mvp-view-demographics",
  MVP_FLAG_APPLICATION = "mvp-flag-application",
  MVP_MANAGE_APPLICATION = "mvp-manage-application",
  MVP_MANUALLY_ASSIGN_APPLICATION = "mvp-manually-assign-application",
  MVP_UPDATE_PRIMARY_EMAIL = "mvp-update-primary-email",
  MSA_VIEW_USERS = "msa-view-users",
  MSA_UPDATE_USERS = "msa-update-users",
  MSA_VIEW_EVENTS = "msa-view-events",
  MSA_REVIEW_EVENTS = "msa-review-events",
  MSA_VIEW_APPLICATIONS = "msa-view-applications",
  MSA_SCORE_APPLICATIONS = "msa-score-applications",
  MSA_REVIEW_APPLICATIONS = "msa-review-applications",
  MSA_ASSIGN_OWNER = "msa-assign-owner",
  MSA_UPDATE_OWNER = "msa-update-owner",
  MSA_ASSIGN_REVIEWER = "msa-assign-reviewer",
  MSA_UPDATE_REVIEWER = "msa-update-reviewer",
  MSA_ASSIGN_GUEST = "msa-assign-guest",
  MSA_UPDATE_GUEST = "msa-update-guest",
  MSA_MANUALLY_ASSIGN_APPLICATIONS = "msa-manually-assign-applications",
  MSA_VIEW_BENEFITS = "msa-view-benefits",
  MSA_UPDATE_BENEFITS = "msa-update-benefits",
  MSA_VIEW_ACCESS_CONTROL = "msa-view-access-control",
  MSA_UPDATE_ACCESS_CONTROL = "msa-update-access-control",
  RD_VIEW_USERS = "rd-view-users",
  RD_UPDATE_USERS = "rd-update-users",
  RD_VIEW_EVENTS = "rd-view-events",
  RD_REVIEW_EVENTS = "rd-review-events",
  RD_VIEW_APPLICATIONS = "rd-view-applications",
  RD_SCORE_APPLICATIONS = "rd-score-applications",
  RD_REVIEW_APPLICATIONS = "rd-review-applications",
  RD_ASSIGN_OWNER = "rd-assign-owner",
  RD_UPDATE_OWNER = "rd-update-owner",
  RD_ASSIGN_REVIEWER = "rd-assign-reviewer",
  RD_UPDATE_REVIEWER = "rd-update-reviewer",
  RD_ASSIGN_GUEST = "rd-assign-guest",
  RD_UPDATE_GUEST = "rd-update-guest",
  RD_MANUALLY_ASSIGN_APPLICATIONS = "rd-manually-assign-applications",
  RD_VIEW_BENEFITS = "rd-view-benefits",
  RD_UPDATE_BENEFITS = "rd-update-benefits",
  RD_VIEW_ACCESS_CONTROL = "rd-view-access-control",
  RD_UPDATE_ACCESS_CONTROL = "rd-update-access-control",
  RD_VIEW_DISTRIBUTIONS_LIST = "rd-view-distributions-list",
  RD_UPDATE_DISTRIBUTIONS_LIST = "rd-update-distributions-list",
  RD_UPDATE_PRIMARY_EMAIL = "rd-update-primary-email",
}

export enum RoleNamesEnum {
  PROGRAM_OWNER = "Program Owner",
  COMMUNITY_MANAGER = "Community Manager",
  PRODUCT_GROUP_PARTNER = "Product Group Partner",
  GUEST = "Guest",
  BENEFITS_MANAGER = "Benefits Manager",
  EXECUTIVE = "Executive",
  BUSINESS_GROUP = "Business Group",
}

export enum ApplicationReviewStatusesEnum {
  PG_REVIEW = "PG-Review",
  CPM_REVIEW = "CPM-Review",
  BG_FINAL_REVIEW = "BG-Final-Review",
}
